import {createFileRoute, Outlet} from '@tanstack/react-router';
import {NoShell} from '@/features/core/components/no-shell';
import {rootLogger} from '@/features/development/services/root-logger';

const routeLogger = rootLogger.getChildLogger('route');

export const Route = createFileRoute('/_public')({
  component: RouteComponent,
});

function RouteComponent() {
  routeLogger.debug('/_public');

  return (
    <NoShell
      slots={{
        main: Outlet,
      }}
    />
  );
}
